import { useAppSelector } from '../store'

export function useWidgetSettings() {
  return useAppSelector(state => ({
    ...state.widgetSettings,
    ...state.app,
  }))
}
